import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/components/portfolio/TagSelector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/components/projects/List/components/Card.tsx");
;
import(/* webpackMode: "eager" */ "/root/ophirstudio_next/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/root/ophirstudio_next/node_modules/next/dist/client/link.js");
